import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { selectConfig, selectContactComments } from '../../../SubscriptionForm/SubscriptionFormSelectors'
import { subscriptionFormActionsV2 } from '../../../SubscriptionForm/SubscriptionFormV2Sagas'
import {
  addCommentToContact,
  removeCommentFromContact,
  updateCommentForContact,
} from '../../../SubscriptionForm/SubscriptionFormSlice'

const useComments = () => {
  const dispatch = useDispatch()
  const [isOpen, setIsOpen] = useState(false)
  const { contactId } = useSelector(selectConfig)
  const comments = useSelector(selectContactComments)
  const { userId, isAdmin } = useSelector(selectAuthData)

  const handleSubmit = (comment, callback) => {
    dispatch({
      type: subscriptionFormActionsV2.ADD_COMMENT_TO_CONTACT_V2,
      comment,
      contactId,
      callback: (response, status) => {
        const success = status === 200 && response?.success
        if (success) {
          dispatch(addCommentToContact(response))
        }
        callback(success)
      },
    })
  }

  const handleUpdate = (commentId, comment, callback) => {
    dispatch({
      type: subscriptionFormActionsV2.UPDATE_COMMENT_FOR_CONTACT_V2,
      commentId,
      comment,
      callback: (response, status) => {
        const success = status === 200 && response?.success
        if (success) {
          dispatch(updateCommentForContact({ id: commentId, comment }))
        }
        callback(success)
      },
    })
  }

  const handleDelete = (commentId, callback) => {
    dispatch({
      type: subscriptionFormActionsV2.DELETE_COMMENT_FROM_CONTACT_V2,
      commentId,
      callback: (response, status) => {
        const success = status === 200 && response?.success
        if (success) {
          dispatch(removeCommentFromContact({ id: commentId }))
        }
        callback(success)
      },
    })
  }

  const canMutate = comment => {
    const authorId = comment?.user?.id ?? comment?.user_id
    return isAdmin === true || authorId === userId
  }

  return {
    isOpen,
    setIsOpen,
    comments,
    handleSubmit,
    handleUpdate,
    handleDelete,
    canMutate,
  }
}

export default useComments
